/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';

import InformationsDeclarant from './InformationsDeclarant';

/**
 * Étape « Déclarant » de l'acte de décès, dernière étape avant les mentions.
 *
 * Les erreurs sont regroupées sous `declarant`, comme l'étape des parents les
 * regroupe sous `parent1`/`parent2` (cf. `validationStepDeclarant`).
 */
const StepDeclarant = () => {
  const { data, onChange, errors } = React.useContext(AssistantContext);

  const errorsStep = errors?.[Steps.Declarant]?.declarant ?? {};

  return (
    <div
      className="assistant-step-declarant"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsDeclarant
        data={data}
        errors={errorsStep}
        onChange={onChange}
      />
    </div>
  );
};

export default StepDeclarant;
